type CreditDaysT = {
  remainingCreditDays: number;
  remainingCreditDaysAfterStart: number;
};

export const getRemainingCreditDays = (organization?: CreditDaysT | null) =>
  organization?.remainingCreditDays || organization?.remainingCreditDaysAfterStart || 0;
